export default __webpack_public_path__ + "static/DINPro-Light-d9efb3873957fe6b0ec53e9db75479ec.eot";